angular.module('wco.directives.packagingSelect', [])
.controller('WcoPackagingSelectController', ['$scope','$uibModal', '$log', function($scope, $uibModal, $log) {
    $scope.open = function() {
        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'angular/directives/packagingSelectModal.html',
            controller: 'WcoPackagingSelectModalController',
            size: 'lg',
        });

        modalInstance.result.then(function (message) {
            $scope.$emit($scope.eventTitle, message);
        }, function () {
            // user clicked abor
        });
    };
}])
.directive('wcoPackagingSelect', ['$timeout', function($timeout) {
    return {
        controller: 'WcoPackagingSelectController',
        controllerAs: 'packingselect',
        templateUrl: function(element, attrs){
            return attrs.templateUrl || 'angular/directives/packagingSelect.html';
        },
        scope:{
            eventTitle: '='
        },
        transclude: true,
        replace: true
    };
}])
.controller('WcoPackagingSelectModalController',  ['$scope','$uibModalInstance', 'packingDaisyService', function ($scope, $uibModalInstance, packingDaisyService) {
    $scope.currentPackagingMeanCategory = false;
    $scope.currentPackagingMean = false;

    packingDaisyService.getPackagingMeans().then((response) => {
        $scope.packagingMeanCategories = response;
    });

    $scope.selectPackagingMeanCategory = function(index){
        $scope.currentPackagingMeanCategory = $scope.packagingMeanCategories[index];
    };

    $scope.unselectPackagingMeanCategory = function(index){
        $scope.currentPackagingMeanCategory = false;
        $scope.currentPackagingMean = false;
    };

    $scope.selectPackagingMean = function(index){
        $scope.currentPackagingMean = $scope.currentPackagingMeanCategory.ITEMS[index];
    };

    $scope.confirmSelection = function () {
        $uibModalInstance.close($scope.currentPackagingMean);
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
}]);